import React from 'react';
import Card from '../Common/Card';
import { formatUSDT, formatTimestamp } from '../../utils/format';
import { ACTIVITY_TYPES } from '../../config/contract';

const ICONS = { 1: '↑', 2: '★', 3: '⚏', 4: '◆', 5: '↓' };

const ActivityFeed = ({ activities }) => {
  const list = (activities || []).slice().reverse();

  return (
    <Card title="Recent Activity" subtitle="Last 50 transactions">
      {list.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">◌</div>
          <div className="empty-state-text">No activity yet</div>
        </div>
      ) : (
        <div className="activity-feed">
          {list.map((a, i) => {
            const type = ACTIVITY_TYPES[a.activityType] || { label: 'Unknown', color: '#fff' };
            return (
              <div key={i} className="activity-item">
                <div className="activity-info">
                  <div className="activity-icon" style={{
                    background: `${type.color}22`,
                    color: type.color
                  }}>{ICONS[a.activityType] || '•'}</div>
                  <div>
                    <div className="activity-label">{type.label}</div>
                    <div className="activity-time">{formatTimestamp(a.timestamp)}</div>
                  </div>
                </div>
                <div className="activity-amount" style={{ color: type.color }}>
                  {formatUSDT(a.amount)} USDT
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};

export default ActivityFeed;
